export const getAnyYouTubeVideoId = (url) => {
  const regExp = /(?:youtube\.com.*(?:\/|v=|vi=|u\/\w\/|embed\/|shorts\/|watch\?v=)|youtu\.be\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[1] ? match[1] : null;
}
